import React from 'react';
import { api } from '../../../services/api'
import { useParams } from "react-router-dom";
import { Stack, Alert, Button, Box } from '@mui/material';
import { maskCNPJ, maskCEP, maskCPF, linhaDigitavel, parseData } from '../../../utils/mask';
import QRCode from 'qrcode';
import JsBarcode from "jsbarcode";


export default function BoletoItau() {
    const [htmlContent, setHtmlContent] = React.useState("");
    const { externalId } = useParams();
    const [error, setError] = React.useState(false)


    React.useEffect(() => {
        async function loadData() {
            try {
                console.log(externalId)
                const response = await api.get(`/order/boleto/${externalId}`)
                console.log(response)
                await loadBolecode(response)
            } catch (error) {
                setError(true)
                console.log(error)

            }
        }
        async function loadBolecode(response) {
            await fetch("/bolecode/index.html")
                .then((response) => response.text())
                .then(async (html) => {
                    const bolecode = response.data.bolecode?.data;
                    const dadoBoleto = bolecode?.dado_boleto;
                    const dadosIndividuais = dadoBoleto?.dados_individuais_boleto?.[0];
                    const beneficiario = bolecode?.beneficiario;
                    const pagador = dadoBoleto?.pagador;
                    const dadosQrcode = bolecode?.dados_qrcode;
                    
                    // Verifica se é um boleto de ordem (order) ou filiação (affiliate-payment)
                    const isAffiliate = response.data.affiliate !== undefined;
                    const event = response.data.event;
                    const subscriber = response.data.subscribers?.[0];

                    const value = new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                    }).format((parseInt(dadoBoleto?.valor_total_titulo || '0', 10) / 100).toFixed(2))
                    
                    let QRpix = '';
                    if (dadosQrcode?.emv) {
                        QRpix = await QRCode.toDataURL(dadosQrcode.emv);
                    }
                    
                    let Codebar = '';
                    if (dadosIndividuais?.codigo_barras) {
                        const canvas = document.createElement("canvas");
                        JsBarcode(canvas, dadosIndividuais.codigo_barras, { format: "CODE128", displayValue: false });
                        const buffer = canvas.toDataURL("image/png");
                        Codebar = buffer.toString('base64');
                    }

                    const dadosBoleto = {
                        LINHA_DIGITAVEL: dadosIndividuais?.numero_linha_digitavel ? linhaDigitavel(dadosIndividuais.numero_linha_digitavel) : '',
                        DATA_VENCIMENTO: dadosIndividuais?.data_vencimento ? parseData(dadosIndividuais.data_vencimento) : '',
                        NOME_BENEFICIARIO: beneficiario?.nome_cobranca || '',
                        CNPJ_BENEFICIARIO: beneficiario?.tipo_pessoa?.numero_cadastro_nacional_pessoa_juridica ? maskCNPJ(beneficiario.tipo_pessoa.numero_cadastro_nacional_pessoa_juridica) : '',
                        LOGRADOURO_BENEFICIARIO: beneficiario?.endereco?.nome_logradouro || '',
                        BAIRRO_BENEFICIARIO: beneficiario?.endereco?.nome_bairro || '',
                        CIDADE_BENEFICIARIO: beneficiario?.endereco?.nome_cidade || '',
                        UF_BENEFICIARIO: beneficiario?.endereco?.sigla_UF || '',
                        CEP_BENEFICIARIO: beneficiario?.endereco?.numero_CEP ? maskCEP(beneficiario.endereco.numero_CEP) : '',
                        DATA_BOLETO: dadoBoleto?.data_emissao ? parseData(dadoBoleto.data_emissao) : '',
                        NUMERO_BOLETO: response.data.external_id || '',
                        PRCOCESSAMENTO_BOLETO: dadoBoleto?.data_emissao ? parseData(dadoBoleto.data_emissao) : '',
                        NOSSO_NUMERO_BOLETO: dadosIndividuais?.numero_nosso_numero || '',
                        VALOR_BOLETO: value,
                        NOME_EVENTO: isAffiliate ? 'FILIAÇÃO APEPREV' : (event?.name ? String(event.name).substring(0, 50) : ''),
                        DOCUMENTO_INSCRITO: isAffiliate ? '' : (subscriber?.document ? maskCPF(subscriber.document) : ''),
                        NOME_INSCRITO: isAffiliate ? '' : (subscriber?.name || ''),
                        NOME_PAGADOR: pagador?.pessoa?.nome_pessoa ? String(pagador.pessoa.nome_pessoa).substring(0, 40) : '',
                        DOCUMENTO_PAGADOR: pagador?.pessoa?.tipo_pessoa?.numero_cadastro_nacional_pessoa_juridica ? maskCNPJ(pagador.pessoa.tipo_pessoa.numero_cadastro_nacional_pessoa_juridica) : '',
                        LOGRADOURO_PAGADOR: pagador?.endereco?.nome_logradouro || '',
                        BAIRRO_PAGADOR: pagador?.endereco?.nome_bairro || '',
                        CIDADE_PAGADOR: pagador?.endereco?.nome_cidade || '',
                        UF_PAGADOR: pagador?.endereco?.sigla_UF || '',
                        CEP_PAGADOR: pagador?.endereco?.numero_CEP ? maskCEP(pagador.endereco.numero_CEP) : '',
                        DAC_TITULO: dadosIndividuais?.dac_titulo || '',
                        CODIGOPIX_BOLETO: QRpix,
                        CODIGOBARRAS_BOLETO: Codebar
                    };
                    console.log({ dadosBoleto })
                    const renderedHtml = html.replace(/{{(.*?)}}/g, (_, key) => dadosBoleto[key.trim()] || "");

                    setHtmlContent(renderedHtml);
                });

        }
        loadData()


    }, []);



    return (
        <>
            {error ? <Stack
                sx={{ display: 'flex', width: '100%', height: '90%', justifyContent: 'center' }}
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}>
                <Alert sx={{ width: '50%',marginTop:'20%' }} severity="error">Erro ao carregar Boleto! Tente novamente mais tarde...</Alert>
                </Stack>
                :
                <Box sx={{ width: '100%', height: '80%', justifyContent: 'center', overflowY: 'hidden' }}>
                    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                    <Button variant="contained" id="print" sx={{ display: 'block', top: '0px' , margin: '0 55%' }} onClick={() => {
                        document.getElementById("print").style.visibility = "hidden";
                        window.print()
                        document.getElementById("print").style.visibility = "visible";
                    }
                    }>Imprimir</Button>
                </Box>
            }
        </>
    )
}